<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 商品中心->售后订单 -->
    <div class="main2" style="padding:0;">
      <div class="main2" style="padding:0;">
        <div class="search" style="padding-bottom:10px;">
          <el-form
            :model="queryParams"
            ref="queryForm"
            :inline="true"
            label-width="90px"
          >
            <el-form-item label="退货单号：" prop="salesReturnNum">
              <el-input
                v-model="queryParams.salesReturnNum"
                placeholder="请输入退货单号"
                clearable
                size="small"
              />
            </el-form-item>
            <el-form-item label="申请时间：" prop="beginTime">
              <el-date-picker
                clearable
                size="small"
                style="width: 150px"
                v-model="queryParams.beginTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="" prop="endTime">
              <el-date-picker
                clearable
                size="small"
                style="width: 150px"
                v-model="queryParams.endTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="截止时间"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button
                icon="el-icon-search"
                size="small"
                style="border-color:#97c5e9"
                @click="search"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>

        <div class="list">
          <el-table
            :data="currentPageInfo"
            style="width: 100%"
            :default-expand-all="true"
            :cell-style="{
              'text-align': 'center',
              'border-color': '#dbdbdb',
              'border-top': '35px solid #e7e6e4',
              position: 'relative',
              'background-color': '#f3f1f2',
              'border-right': '1px solid #e7e6e4',
            }"
            :header-cell-style="{
              'background-color': '#b6b6b6',
              color: '#000',
              fontSize: '14px',
              fontWeight: '300',
              'text-align': 'center',
            }"
            @selection-change="SelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="num" align="center" label="序号" width="65">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>

            <el-table-column
              prop="salesReturnNum"
              label="退货单号"
              min-width="140"
            >
              <template slot-scope="scope">
                <el-link :underline="false" @click="watchOrder(scope.row)">{{
                  scope.row.salesReturnNum
                }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="linkman" label="联系人" min-width="95">
              <template slot-scope="scope">
                {{ scope.row.linkman }}
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="联系电话" min-width="110">
              <template slot-scope="scope">
                {{ scope.row.phone }}
              </template>
            </el-table-column>
            <el-table-column prop="orderNum" label="订单编号" min-width="140">
              <template slot-scope="scope">
                {{ scope.row.orderNum || "未关联" }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="申请时间" min-width="165">
              <template slot-scope="scope">
                {{ scope.row.createTime || "" }}
              </template>
            </el-table-column>
            <el-table-column width="5" type="expand">
              <template slot-scope="props">
                <el-form label-position="left" inline class="demo-table-expand">
                  <el-form-item label="订单商品：" style="width:100%;">
                    {{ props.row.goodsDetail || "" }}
                  </el-form-item>
                  <el-form-item label="售后原因：" style="width:100%;">
                    {{ props.row.detail }}
                  </el-form-item>
                  <el-form-item label="回寄时间：">
                    <span>{{ props.row.backDeliveryTime || "" }}</span>
                  </el-form-item>
                  <el-form-item label="回寄快递：">
                    <span>{{ props.row.backDeliveryName }}</span>
                  </el-form-item>
                  <el-form-item label="回寄单号：">
                    <span>{{ props.row.backDeliveryNum }}</span>
                  </el-form-item>
                  <el-form-item label="" align="right">
                    <el-button
                      size="mini"
                      type="primary"
                      icon="el-icon-view"
                      @click="watchOrder(props.row)"
                      >详情</el-button
                    >
                    <span v-html="'\u00a0\u00a0\u00a0\u00a0'"></span>
                  </el-form-item>
                  <el-form-item label="处理结果：" style="width:100%;">
                    {{ props.row.result }}
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>

            <el-table-column prop="status" label="状态" min-width="75">
              <template slot-scope="scope">
                <span>{{ getStatus(scope.row.status) || "" }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-pagination
          v-if="totalPages > 1"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <el-button
          size="mini"
          v-if="totalPages > 1"
          style="display:inline-block;"
          >GO</el-button
        >
      </div>
    </div>
    <!-- 商品中心->售后订单 -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import { getSalesReturnListRequest } from "../../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      totalPages: 1, //总页码,
      pageNum: 1, //当前页码
      total: 1, //总条数
      pageSize: 10, //每页条数
      currentPageInfo: [], //数据列表
      token: "", //token
      salesReturnNum: "", // 1.7.售后订单号
      queryParams: {
        salesReturnNum: null,
        orderNum: null,
        beginTime: null,
        endTime: null,
      },
    };
  },

  components: {
    // 2.components
  },

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getCurrentPageInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getCurrentPageInfo();
    },

    getCurrentPageInfo() {
      // 3.4.获取订单数据
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderNum: this.queryParams.orderNum,
        salesReturnNum: this.queryParams.salesReturnNum,
        params: {
          beginTime: this.queryParams.beginTime,
          endTime: this.queryParams.endTime,
        },
      };

      getSalesReturnListRequest(data).then((res) => {
        if (res) {
          this.total = res.totals || 1;
          this.totalPages = Math.ceil(res.totals / this.pageSize) || 1;
          this.currentPageInfo = res.data;
        }
      });
    },
    search() {
      //检索
      this.pageNum = 1;
      this.getCurrentPageInfo();
    },

    watchOrder(item) {
      // 3.6.查看订单详情
      this.$router.push("/returnOrderDetail?orderId=" + item.salesReturnId);
    },
    getStatus(v) {
      let rr = ""; //0待提报1待审核2待处理3已处理4已取消
      let ary = [];
      ary.push({ id: 0, name: "待处理" });
      ary.push({ id: 1, name: "已处理" });
      ary.push({ id: 2, name: "已处理" });
      ary.push({ id: 3, name: "待提报" });
      for (let i = 0; i < ary.length; i++) {
        if (ary[i].id == v) {
          rr = ary[i].name;
          break;
        }
      }
      return rr;
    },

    SelectionChange() {},
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getCurrentPageInfo(); // 4.1.获取订单数据
    }
  },
};
</script>
